import { render, staticRenderFns } from "./CommonWaitingListFilter.vue?vue&type=template&id=23a64bcb"
import script from "./CommonWaitingListFilter.vue?vue&type=script&lang=js"
export * from "./CommonWaitingListFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports